import { Base } from "./../../framework/base";
import { ListItems } from "./../../framework/listItems";
import { EventUrgencyClassListItem, IEventUrgencyClassListItem } from "./eventUrgencyClassListItem";

export interface IEventUrgencyClassListItems extends ListItems<IEventUrgencyClassListItem> { }

export class EventUrgencyClassListItems extends ListItems<EventUrgencyClassListItem> implements IEventUrgencyClassListItems {
    constructor();
    constructor(obj: IEventUrgencyClassListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, EventUrgencyClassListItem);
    }
}